import React from 'react';

import Spinner from './Spinner';

/**
 * The one on-screen presentation of a loading state.
 *
 * Rendered solely by `SpinnerProvider`. Nothing else should mount this — doing
 * so reintroduces a second render site and, with it, stacked scrims.
 *
 * `scrim` dims and covers what is behind the spinner. It belongs to a load that
 * makes the whole screen unusable; a page that is still readable while one
 * region loads asks for it without.
 */
const FullscreenSpinner: React.FC<{ scrim?: boolean }> = ({ scrim = true }) => {
  return (
    <div
      className={`fixed top-0 left-0 w-full h-full z-50 flex items-center justify-center ${
        scrim ? 'bg-core-elements-background-overlay' : 'pointer-events-none'
      }`}
      data-testid="fullscreen-spinner"
    >
      <Spinner />
    </div>
  );
};

export default FullscreenSpinner;
